<div *ngIf="load && companies && companies.length > 0">
    <div class="stores-carousel">

        <button type="button" class="btn btn-control prev"
            (click)="direction.isRTL() ? carousel.next() : carousel.prev()"><mat-icon>chevron_left</mat-icon></button>
        <button type="button" class="btn btn-control next"
            (click)="direction.isRTL() ? carousel.prev() : carousel.next()"><mat-icon>chevron_right</mat-icon></button>

        <owl-carousel-o [options]="carouselOptions" appOwlPreventClick #carousel>
            <ng-template *ngFor="let company of companies" carouselSlide [width]="170">
                <div class="vendor-block bg-card-new card-radius-x1" appClick
                    [routerLink]="['/vendor', company.seo?.slug]">
                    <div class="vendor-block-image flex flex-col justify-center">
                        <img class="image" [src]="company?.design?.logo?.url"
                            [alt]="translationHelper.localize(company.name)">
                    </div>
                </div>
            </ng-template>
        </owl-carousel-o>
    </div>
</div>